/**
 * card-grid-modal.js
 * Shared open/close/populate mechanics for the site's "view all X"
 * card-grid modals (backdrop + dialog + grid + close). Pages own their
 * markup (a .cgm-modal root with a grid target element, styled via
 * css/components/card-grid-modal.css) and their own card-render/click-
 * bind logic; this module just does the DOM plumbing every instance
 * used to duplicate. Filter bars and pagination footers (.cgm-filter-bar,
 * .cgm-pagination) are optional markup a page can include — this module
 * doesn't know about them, the owning page wires its own click handlers
 * for those exactly as it did before migrating to this shell.
 */

function open({ modalId, gridId, items, renderItem, bindClicks, titleId, title }) {
  const modal = document.getElementById(modalId);
  const grid = document.getElementById(gridId);
  if (!modal || !grid) return;

  if (titleId && title != null) {
    const titleEl = document.getElementById(titleId);
    if (titleEl) titleEl.textContent = title;
  }

  // items/renderItem are optional — a page that already keeps its grid
  // populated independently of the open() call (e.g. built continuously
  // off a separate data-arrival observer) can omit them and use this
  // purely to show the modal + lock scroll.
  if (items && renderItem) {
    grid.innerHTML = items.map(renderItem).join('');
  }
  if (bindClicks) bindClicks(grid, items);

  modal.classList.add('active');
  document.body.style.overflow = 'hidden';
}

function close(modalId) {
  const modal = document.getElementById(modalId);
  if (modal) modal.classList.remove('active');
  document.body.style.overflow = '';
}

// One shared Escape-key handler for every .cgm-modal on the page, so
// individual pages don't each need to wire their own keydown listener.
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  const openModal = document.querySelector('.cgm-modal.active');
  if (openModal) close(openModal.id);
});

window.CardGridModal = { open, close };

export { open, close };
